import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Autocomplete,
} from "@mui/material";

const ICD_REASONS = [
  "Not documented in progress notes",
  "Screening is not yet done",
  "Conditions mentioned in family history",
  "Symptoms are denied",
  "Diagnosis resolved/currently not active",
];

const CPT_REASONS = [
  "Physician did not cover the service",
  "Screening not completed in this visit",
  "Vitals value not matching",
  "Relevant ICD/diagnosis not present",
  "Age mismatching",
  "Lab value mismatching",
  "Services not covered by Insurances",
];

const NoteDialog = ({
  open,
  onClose,
  note,
  setNote,
  onSubmit,
  submitting,
  showICD,
}) => {
  const reasons = showICD ? ICD_REASONS : CPT_REASONS;
  return (
    <Dialog open={open} fullWidth maxWidth="sm" onClose={onClose}>
      <DialogContent>
        <Autocomplete
          freeSolo
          options={reasons}
          value={note || ""}
          onInputChange={(_, value) => setNote(value)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Note"
              variant="outlined"
              helperText="Select a reason or type custom note"
              fullWidth
              multiline
              minRows={3}
            />
          )}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="text">
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onSubmit}
          disabled={submitting}
        >
          {submitting ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "Submit"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NoteDialog;
